import React from "react";
import { useTranslation } from "react-i18next";
import BlueCross from "../../../../assets/icons/cross_blue.svg";
import { FilterMap } from "../../../../constants/propertyData";
import { ILocationFilter } from "../../interfaces";
import { useLanguageTheme } from "../../../../hooks/useLanguageTheme";

export const LocationMobileFilterItem = ({
  filterMap = {},
  selectedFilters = [],
  onChange,
  truncateLength,
}: {
  filterMap: FilterMap;
  selectedFilters: ILocationFilter[];
  onChange: (filters: ILocationFilter[]) => void;
  truncateLength: number;
}) => {
  const { i18n } = useTranslation(["portfolio"]);
  const isRTL = i18n.dir() === "rtl";
  const langTheme = useLanguageTheme();

  if (selectedFilters.length === 0) {
    return null;
  }

  const handleClearFilter = () => {
    onChange([]);
  };

  return (
    <div className="portfolio-mobile-filter-item">
      <div
        style={{
          fontFamily: langTheme.mainFont(),
          fontWeight: isRTL ? 400 : 500,
        }}
      >
        {selectedFilters.map((el: any, index) => (
          <div>{i18n.language === "he" ? el?.name?.he : el?.name?.en}</div>
        ))}
      </div>
      <div
        className="portfolio-mobile-filter-item-cross-container"
        onClick={() => handleClearFilter()}
      >
        <img src={BlueCross} />
      </div>
    </div>
  );
};
